import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import ServiceChannelsBody from './ServiceChannelsBody';
import ServiceChannelsData from './ServiceChannelsData';

const Edit = (props) => {
  const { data, block, selected, intl } = props;

  return (
    <>
      <ServiceChannelsBody data={data} id={block} intl={intl} isEditMode />
      <SidebarPortal selected={selected}>
        <ServiceChannelsData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
